// extracted by mini-css-extract-plugin
module.exports = {"chart":"TopDevice_chart__1hBgO","legend":"TopDevice_legend__7ijrp","title":"TopDevice_title__2YT5b","percent":"TopDevice_percent__2kAOj"};